import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import { Draw } from 'ol/interaction';
import { toLonLat } from 'ol/proj';
import { Vector as VectorSource } from 'ol/source';
import React, { useMemo } from 'react';
import { RiCircleLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import { FENCE_CIRCLE_RADIUS_MIN } from '@/config';
import { STYLES } from '@/define/olMaps';
import OlMap from '@/helpers/OlMap';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';
import { NotifierService as notifier } from '@/libs/Notifier';
import CoordUtils from '@/utils/CoordUtils';
import { convertProjectedRadiusToMeters } from '@/utils/FenceUtil';

const cx = classNames.bind(styles);

const DrawCircle = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.editor.mode);
  const map = OlMap.getMap();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const pressed = useMemo(() => {
    return mode === 'fence/circle';
  }, [mode]);

  useUpdateEffect(() => {
    if (!pressed) return;

    const interaction = new Draw({
      source: new VectorSource({ wrapX: false }),
      type: 'Circle',
      style: STYLES.MISSION.FENCE,
    });
    interaction.on('drawend', drawCircle);
    map.addInteraction(interaction);

    return () => {
      map.removeInteraction(interaction);
    };
  }, [pressed]);

  const drawCircle = (e) => {
    const circle = e.feature.getGeometry();
    const radius = convertProjectedRadiusToMeters(circle);
    // 반지름 10m 미만 시
    if (radius < FENCE_CIRCLE_RADIUS_MIN) {
      notifier.error(`The fence radius cannot be smaller than ${FENCE_CIRCLE_RADIUS_MIN}m. Please redraw.`);
      return;
    }

    const center = CoordUtils.objectFromArray(toLonLat(circle.getCenter()));

    dispatch(actions.mission.mavlink.addFence('Circle', { center, radius }));
    dispatch(actions.editor.changeMode(null));
  };

  const toggle = () => {
    if (pressed) {
      dispatch(actions.editor.changeMode(null));
    } else {
      dispatch(actions.editor.changeMode('fence/circle'));
    }
  };

  return (
    <div className={cx('container')}>
      <div className={cx(['button', { pressed }])} onClick={handleWithMoveCheck(toggle)}>
        <RiCircleLine size={20} />
        <div className={cx('label')}>Circle</div>
      </div>
    </div>
  );
};

export default DrawCircle;
